import { render, staticRenderFns } from "./areaMyChecklistProjects.vue?vue&type=template&id=5fcd9c0d&scoped=true"
import script from "./areaMyChecklistProjects.vue?vue&type=script&lang=js"
export * from "./areaMyChecklistProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd9c0d",
  null
  
)

export default component.exports